/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Account Info EDM Delivery Component
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { FC } from 'react';

import { useSelector } from 'react-redux';

import { icons } from '@assets/index';
import { InfoBlock, LinkBlock } from '@components/common';
import { ImgStyled } from '@components/common/Block/Img';
import { EColorStatus } from '@modules/app/appConstants';
import { makeSelectPageAccountInfoTranslation } from '@modules/internationalization/intSelectors';

import { AccountDeliveryEdmInfoStyled, EdmInfoLinkContainerStyled, EdmInfoLinkStyled, EdmInfoTextStyled, EdmInfoTitleStyled } from '../styled/AccountInfoDeliveryStyled';

interface IProps {
    edmDescriptionLink?: string;
};

export const EdmInfoBLock: FC<IProps> = ({ edmDescriptionLink }) => {
    const { delivery: tDelivery } = useSelector(makeSelectPageAccountInfoTranslation());

    return (
        <InfoBlock colorStatus={EColorStatus.INFO}>
            <AccountDeliveryEdmInfoStyled>
                <EdmInfoTitleStyled>
                    {tDelivery.edmInfoBlockTitle}
                </EdmInfoTitleStyled>
                <EdmInfoTextStyled>
                    {tDelivery.edmInfoBlockText}
                </EdmInfoTextStyled>
                <LinkBlock
                    isExternalUrl={true}
                    target='_blank'
                    url={edmDescriptionLink}
                >
                    <EdmInfoLinkContainerStyled>
                        <EdmInfoLinkStyled>
                            {tDelivery.details}
                        </EdmInfoLinkStyled>
                        <ImgStyled height='8px' src={icons.arrowRightInfoSmall} width='5px' />
                    </EdmInfoLinkContainerStyled>
                </LinkBlock>
            </AccountDeliveryEdmInfoStyled>
        </InfoBlock>
    );
};
